import {AWSJSONValue, DriftFinding} from '../types';

// FNP-585 / known billing-api gotcha: AWSJSON fields that store a pre-stringified
// value come back double- (sometimes triple-) encoded. A single JSON.parse leaves
// the inner string, so every nested field reads as undefined. Parse-until-object:
// repeatedly JSON.parse while the result is still a string, up to a small bound so a
// genuinely string-valued payload can't loop forever.
export const parseAwsJson = (value: AWSJSONValue | undefined): unknown => {
    if (value === null || value === undefined) {
        return null;
    }

    let current: unknown = value;
    for (let i = 0; i < 3; i++) {
        if (typeof current !== 'string') {
            break;
        }
        try {
            current = JSON.parse(current);
        } catch {
            // Not JSON (or no longer JSON) — return the string as-is.
            break;
        }
    }
    return current;
};

// Parse the BindingDriftReport.findings AWSJSON into a typed array. The sweep stores
// an array of {accountId, sourceCustomerId, projectionCustomerId, action,
// sourceVersion}; anything else (null, a non-array) yields an empty list so the
// detail table never crashes on a malformed payload.
export const parseFindings = (value: AWSJSONValue | undefined): DriftFinding[] => {
    const parsed = parseAwsJson(value);
    if (!Array.isArray(parsed)) {
        return [];
    }
    return parsed as DriftFinding[];
};
